<template>
  <StorageMenu v-if="data?.menu" v-bind="data.menu" />
</template>

<script lang="ts" setup>
import type { LoadActiveMenuQueryVariables } from '#build/graphql-operations'

const { activeChannel } = useSiteContext()
const language = useCurrentLanguage()

const variables = computed<LoadActiveMenuQueryVariables>(() => ({
  channel: activeChannel.value,
}))

const key = computed(
  () => `app-header-${language.value}-${activeChannel.value}`,
)

const { data } = await useCachedAsyncData(
  key.value,
  () =>
    useGraphqlQuery('loadActiveMenu', variables.value, {
      graphqlCaching: {
        client: true,
      },
    }),
  {
    serverMaxAge: 60 * 60,
    clientMaxAge: 'never',
    serverCacheTags: (data) => {
      return data.extensions?.cacheability?.tagsNuxt || []
    },
    transform: function (data) {
      const menu = data.data.loadMenuForChannel
      const cacheability = data.extensions?.cacheability
      return { menu, cacheability }
    },
    watch: [language, variables],
    deep: false,
  },
)

useGraphqlCacheability(data.value)
</script>
